import { atom } from 'recoil';

export const ShowPoiControlState = atom({
    key: 'ShowPoiControlState', 
    default: true, 
});